import React, { createContext, useState } from 'react';
import {
  DEFAULT_THEME,
  APPEARANCE_SETTINGS_THEME_LOCALSTORAGE_KEY
} from '../config/constants';

export type ThemeType = 'light' | 'dark';

export interface ThemeContextState {
  theme: ThemeType
  setTheme: (theme: ThemeType) => void
};

// initiate theme context
export const ThemeContext = createContext<ThemeContextState | null>(null);

// theme context provider
export const ThemeProvider = ({ children }: any): JSX.Element | null => {
  const systemPreferredTheme = window.matchMedia(
    '(prefers-color-scheme: dark)'
  ).matches ? null : 'dark';
  const settingsTheme = localStorage.getItem(APPEARANCE_SETTINGS_THEME_LOCALSTORAGE_KEY) as ThemeType;

  const [theme, setTheme] = useState<ThemeType>(settingsTheme || systemPreferredTheme || DEFAULT_THEME);

  // construct theme context
  const themeContext: ThemeContextState = {
    theme,
    setTheme
  }

  return (
    <ThemeContext.Provider value={themeContext}>
      {children}
    </ThemeContext.Provider>
  );
};
